var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9989 4.59137C20.0036 4.51566 19.9934 4.43975 19.9688 4.36831C19.9442 4.29686 19.9057 4.23141 19.8557 4.176C19.8058 4.12058 19.7454 4.07637 19.6783 4.0461C19.6113 4.01583 19.5389 4.00014 19.4658 4H4.53425C4.46108 4.00003 4.3887 4.01565 4.32158 4.04588C4.25446 4.07612 4.19405 4.12032 4.14407 4.17576C4.0941 4.2312 4.05563 4.2967 4.03105 4.36819C4.00648 4.43968 3.99631 4.51564 4.00119 4.59137C4.12653 6.4017 4.81921 8.11984 5.9736 9.48381C7.128 10.8478 8.68076 11.7827 10.3951 12.1461V19.4458C10.3952 19.5511 10.4241 19.6543 10.4787 19.7432C10.5332 19.8321 10.611 19.903 10.7029 19.9477C10.7949 19.9924 10.8973 20.0089 10.998 19.9954C11.0987 19.982 11.1937 19.939 11.2717 19.8716L13.4097 18.0236C13.4699 17.9716 13.5184 17.9065 13.5517 17.8329C13.5849 17.7593 13.6021 17.6791 13.6021 17.5978V12.1461C15.317 11.7834 16.8705 10.8487 18.0255 9.4847C19.1804 8.12066 19.8735 6.40215 19.9989 4.59137Z",
    stroke: "#424242",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilter);
export default __webpack_public_path__ + "static/media/icon_filter.78027e1e62840f0efc3b4caa3fab882c.svg";
export { ForwardRef as ReactComponent };